window.jQuery = window.$ = require('jquery');
let processInclude = require('./util');
$(document).ready(function () {
  processInclude(require('./fc-menu'));
});
